import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CurrentUserStore } from '../services/current-user-store';

/**
 * Route guard factory: passes when the user holds the permission OR is their
 * customer's designated billing contact. The billing contact must reach the
 * service agreement to sign it (WI 41969) even when they hold no billing
 * permission at all. Fails closed and redirects to the dashboard, matching
 * permissionGuard.
 */
export const billingContactOrPermissionGuard = (permissionKey: string): CanActivateFn => async () => {
  const store = inject(CurrentUserStore);
  const router = inject(Router);

  if (store.me() === null) {
    await store.load();
  }

  if (store.hasPermission(permissionKey) || store.isBillingContact()) return true;
  return router.createUrlTree(['/dashboard']);
};
